import api from '../../helpers/axios'

export const state = {
    contractPayment: null,
    contractPayments: []
};

export const getters = {
    contractPayment: (state) => state.contractPayment,
    contractPayments: (state) => state.contractPayments
};

export const mutations = {
    setContractPayment(state, newValue) {
        state.contractPayment = newValue;
    },
    setContractPayments(state, newValue) {
        state.contractPayments = newValue;
    },
};

export const actions = {
    createContractPayment(_, {contractId, data}) {
        return new Promise((resolve) => {
            api.post(`/contracts/${contractId}/payments`, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    payInstallment(_, {contractId, data}) {
        return new Promise((resolve) => {
            api.post(`/contracts/${contractId}/pay`, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    makeDiscount(_, {contractId, data}) {
        return new Promise((resolve) => {
            api.post(`/contracts/${contractId}/make-discount`, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    downPay(_, {contractId, data}) {
        return new Promise((resolve) => {
            api.post(`/contracts/${contractId}/down-pay`, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updateContractPayment(_, {contractId, id, data}) {
        return new Promise((resolve) => {
            api.put(`/contracts/${contractId}/payments/`+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deleteContractPayment(_, {contractId, id}) {
        return new Promise((resolve) => {
            api.delete(`/contracts/${contractId}/payments/`+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchPaymentLogs(_,{contractId}){
        return new Promise((resolve,reject) => {
            api.get(`/contracts/${contractId}/payment-logs/`).then((res) => {
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchContractPayment({ commit }, {contractId, id}) {
        return new Promise((resolve,reject) => {
            api.get(`/contracts/${contractId}/payments/`+id).then((res) => {
                commit("setContractPayment", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchContractPayments({ commit }, {contractId}) {
        let query = "?";
        query += `page=1&`;
        query += `limit=99&`;
        return new Promise((resolve) => {
            api.get(`/contracts/${contractId}/payments`+query).then((res) => {
                commit("setContractPayments", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
